import * as React from "react";
import { useQuery, useSubscription } from "urql";
import { tokenEventsSubscription, tokensQuery } from "../../support/mutations";
import { useState } from "react";
import { useEffect } from "react";
import sound from "../../config/sound.mp3";
import useSound from "use-sound";
import Zoom from "@mui/material/Zoom";
import { TransitionGroup } from "react-transition-group";
import { Container, Paper } from "@mui/material";
import { useRef } from "react";
import TokenAccordion from "./TokenAccordion";
import TokenFilter from "./TokenFilter";

const DeploymentsResult = ({
  variables,
  isLastPage,
  onLoadMore,
  filters,
  setFilters,
}) => {
  const nodeRef = useRef(null);
  //TODO add tokens in background
  const [{ data, fetching, error }] = useQuery({
    query: tokensQuery,
    variables: {
      page: variables,
      filter: filters,
    },
  });
  const tokens = data?.tokens;

  const handleScroll = () => {
    if (
      tokens &&
      tokens.pageInfo.hasNextPage &&
      isLastPage &&
      document.body.scrollHeight / 2 < window.scrollY + window.innerHeight
    ) {
      onLoadMore(tokens.edges[tokens.edges.length - 1].cursor);
    }
  };
  if (isLastPage) window.addEventListener("scroll", () => handleScroll());

  // useEffect(() => {
  //   if (isLastPage && filters.query == "") refetchTokens();
  // }, [filters]);

  return (
    <>
      {error && <p>Oh no... {error.message}</p>}
      {tokens && (
        <>
          <TransitionGroup>
            {tokens.edges.map(({ node }) => (
              <Zoom key={node.address} nodeRef={nodeRef}>
                <Paper sx={{ marginBottom: 1 }}>
                  <TokenAccordion token={node} filters={filters} />
                </Paper>
              </Zoom>
            ))}
          </TransitionGroup>
          {fetching && <p>Loading...</p>}
        </>
      )}
    </>
  );
};

const Deployments = ({ checksums, liqOnDeployments, topic }) => {
  const [play, { stop }] = useSound(sound);
  const [pageVariables, setPageVariables] = useState([
    { first: 25, after: "" },
  ]);
  const [filters, setFilters] = useState({
    query: "",
    checksums,
    liqOnDeployments,
  });
  useSubscription(
    {
      query: tokenEventsSubscription,
      variables: {
        filter: {
          ...filters,
          contractState:
            filters.contractState === "PENDING" ? null : filters.contractState,
        },
      },
    },
    () => play()
  );

  useEffect(() => {
    play();
    stop();
  }, [play, stop]);

  useEffect(() => {
    setPageVariables([{ after: "", first: 25 }]);
  }, [filters]);

  return (
    <Container fixed sx={{ marginTop: 2 }}>
      <Paper elevation={5} sx={{ marginBottom: 0 }}>
        <TokenFilter
          liqOnDeployments={liqOnDeployments}
          filters={filters}
          setFilters={setFilters}
          topic={topic}
        />
      </Paper>
      {pageVariables.map((variables, i) => (
        <DeploymentsResult
          filters={filters}
          setFilters={setFilters}
          key={"" + variables.after}
          variables={variables}
          isLastPage={i === pageVariables.length - 1}
          onLoadMore={(after) =>
            setPageVariables([...pageVariables, { after, first: 25 }])
          }
        />
      ))}
    </Container>
  );
};

export default Deployments;
